import React from 'react';
import Card from '../card/Card';
import P from '../texts/p/P';
import Modal from './modal';

interface ReadyToInstrumentModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSecondaryAction: () => void;
  onPrimaryAction: () => void;
  loadingPrimaryBtn?: boolean;
}

const ReadyToInstrumentModal: React.FC<ReadyToInstrumentModalProps> = ({
  isOpen,
  onClose,
  onSecondaryAction,
  onPrimaryAction,
  loadingPrimaryBtn = false
}) => {
  const renderContent = () => (
    <Card>
      <P type='2' variant='neutral' modifier='regular'>
        Esta acción marcará la carpeta como lista para continuar con la instrumentación. 
        ¿Estás seguro de que deseas continuar?
      </P>
    </Card>
  );

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="¿Cambiar estado a 'Para instrumentar'?"
      primaryText={loadingPrimaryBtn ? 'Cambiando...' : 'Confirmar'}
      primaryVariant='primary'
      secondaryVariant='secondary'
      secondaryText='Cancelar'
      onSecondaryAction={onSecondaryAction}
      onPrimaryAction={onPrimaryAction}
      children={renderContent()}
      loadingPrimaryBtn={loadingPrimaryBtn}
    />
  );
};

export default ReadyToInstrumentModal;
